import {
  getDirectorySuccess,
  getDirectoryFail,
  addDirectorySuccess,
  addDirectoryFail,
  getDepartmentsSuccess,
  getDepartmentsFail,
  updateSingleDirectorySuccess,
  updateSingleDirectoryFail,
  deleteSingleDirectorySuccess,
  deleteSingleDirectoryFail,
  addBulkDirectorySuccess,
  addBulkDirectoryFail,
  directoryBulkDataReportClear,
} from "../constant";
import { toast } from "react-toastify";

export const initialState = {
  directory: {},
  departments: [],
  bulkAddDirectoryReport: [],
};

let toastConfig = {
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 2500,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case addDirectorySuccess:
      return {
        ...state,
        directory: {
          ...state.directory,
          results: [action.payload, ...state.directory.results],
          totalResults: state.directory.totalResults + 1,
        },
      };
    case addBulkDirectorySuccess:
      return {
        ...state,
        bulkAddDirectoryReport: action.payload,
      };

    case directoryBulkDataReportClear:
      return {
        ...state,
        bulkAddDirectoryReport: null,
      };
    case getDirectorySuccess:
      return {
        ...state,
        directory: action.payload,
      };
    case getDepartmentsSuccess:
      return {
        ...state,
        departments: action.payload,
      };

    case updateSingleDirectorySuccess:
      return {
        ...state,
        directory: {
          ...state.directory,
          results: state.directory.results.map((item) =>
            item.id === action.payload.id ? action.payload : item,
          ),
        },
      };

    case deleteSingleDirectorySuccess:
      return {
        ...state,
        directory: {
          ...state.directory,
          results: state.directory.results.filter(
            (item) => item.id !== action.payload._id,
          ),
          totalResults: state.directory.totalResults - 1,
        },
      };

    case getDirectoryFail:
    case addDirectoryFail:
    case addBulkDirectoryFail:
    case getDepartmentsFail:
    case updateSingleDirectoryFail:
    case deleteSingleDirectoryFail:
      toast.error(action.payload.message, toastConfig);
      return state;
    default:
      return state;
  }
}
